export const TENANT_CONFIG_REQUEST = 'TENANT_CONFIG_REQUEST';
export const TENANT_CONFIG_SUCCESS = 'TENANT_CONFIG_SUCCESS';
export const TENANT_CONFIG_FAIL    = 'TENANT_CONFIG_FAIL';
export const TENANT_CONFIG_RESET   = 'TENANT_CONFIG_RESET';
